import debugLogger from './debugLogger';

export default function required(name) {
  debugLogger.log('In required parameter function -- about to throw error');
  const nameString = name ? ` ${name}` : '';
  throw new Error(`You did not provide a required parameter${nameString}`);
}
